import Header from "./components/Header";
import GreyLink from "./components/GreyLink";
import Meta from "../../components/Meta";
import WalletList from "../../wallet/WalletList";

const Wallet = () => {
	return (
		<>
			<Meta title="Wallet" />
			<Header
				heading={"Wallet"}
				subHeading={"Manage your balance and top up packages"}
				button={<GreyLink to={"/account"} label={"Back to Account"} />}
			/>
			<div className={"container mx-auto p-6 pt-0 grid grid-cols-1 gap-4"}>
				<WalletList basePath="/account/wallet" />
			</div>
		</>
	);
};

export default Wallet;
